import ProgressBar from "components/ProgressBar/ProgressBar";
import {
    ListActionScopeContext,
    selectProgressForScope,
} from "containers/Resources/listActionScope";
import { getListActionProgress } from "containers/Resources/Resources.selectors";
import { useContext } from "react";
import { useSelector } from "react-redux";
import "./ListActionProgress.scss";

/**
 * Renders the progress bar for bulk actions acting on THIS table only. The scope
 * defaults to the surrounding table's ListActionScopeContext (its
 * tableSettingsKey); pass `scopeId` to override. Unscoped (global) actions still
 * show in every table — see listActionScope.ts.
 */
export const ListActionProgress = ({ scopeId }: { scopeId?: string }) => {
    const contextScopeId = useContext(ListActionScopeContext);
    const effectiveScopeId = scopeId ?? contextScopeId;
    const progressMap = useSelector(getListActionProgress);
    const progress = selectProgressForScope(progressMap, effectiveScopeId);

    if (!progress) {
        return null;
    }

    const percentage =
        progress.total > 0 ? Math.round((progress.current / progress.total) * 100) : 0;

    return (
        <div className="listActionProgress" role="status" aria-live="polite">
            <span className="listActionProgress__label">
                {progress.label} ({progress.current}/{progress.total})
            </span>
            <ProgressBar percentage={percentage} />
        </div>
    );
};
